export default __webpack_public_path__ + "static/media/discardbox_quarterview.93f85266.png";